import { render, staticRenderFns } from "./videoConfGridItem.vue?vue&type=template&id=6fbd072a&scoped=true&lang=pug"
import script from "./videoConfGridItem.vue?vue&type=script&lang=js"
export * from "./videoConfGridItem.vue?vue&type=script&lang=js"
import style0 from "./videoConfGridItem.vue?vue&type=style&index=0&id=6fbd072a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbd072a",
  null
  
)

export default component.exports